import * as analytic from '@anm/analytic';
import Image from '@anm/components/image/Image';
import ShareButton from '@anm/components/share/ShareButton';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';
import { VideoRatioVariants } from '../VideoRatioList';

import EditButton from './EditButton';
import {
  DescriptionRow,
  PremiumIconWrapper,
  TemplateVideoBottomWrapper,
  TitleRow,
  VideoDescription,
  VideoTitleBlock
} from './Wrapper';
import { useShareLink } from './hooks';
import { EditButtonProps } from './types';

export type TemplateVideoBottomProps = EditButtonProps & {
  variant: VideoRatioVariants;
  withDescription?: boolean;
  showShareButton?: boolean;
};

const TemplateVideoBottom: FC<TemplateVideoBottomProps> = ({
  withDescription,
  showShareButton,
  ...buttonProps
}) => {
  const shareLink = useShareLink();
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  const trackShareEvent = useCallback(
    (serviceName: string) => analytic.trackShareEvent(serviceName),
    []
  );

  if (!currentTemplate) return null;

  const { description, meta, displayName } = currentTemplate;
  const isPremium = meta.price > 0;

  return (
    <TemplateVideoBottomWrapper isRow={!!showShareButton}>
      <DescriptionRow>
        <TitleRow>
          {showShareButton && (
            <ShareButton
              link={shareLink}
              title={displayName}
              variant="white-bordered-share"
              onShare={trackShareEvent}
            />
          )}
          <EditButton isSingleButton={showShareButton} {...buttonProps} />
          {withDescription && (
            <VideoTitleBlock {...{ isPremium }}>
              {displayName}
              {isPremium && (
                <PremiumIconWrapper>
                  <Image src="images/icons/crown.svg" alt={description} />
                </PremiumIconWrapper>
              )}
            </VideoTitleBlock>
          )}
        </TitleRow>
        {withDescription && <VideoDescription>{description}</VideoDescription>}
      </DescriptionRow>
    </TemplateVideoBottomWrapper>
  );
};

export default TemplateVideoBottom;
